<script>
import StoreButton from '@/components/app/shared/StoreButton'
import FadeSlideUp from '@/components/transitions/FadeSlideUp'
import { storeButtons } from '@/data/app'

export default {
  components: { StoreButton, FadeSlideUp },
  data() {
		return {
			storeButtons,
		}
	},
}
</script>

<template>
	<FadeSlideUp>
		<section
			class="ml-12 p-6 flex items-center gap-16 border"
			style="
				min-width: 554px;
				background: rgba(179, 159, 159, 0.20);
				border-color: rgba(255, 255, 255, 0.60);
				border-radius: 16px;
				backdrop-filter: blur(20px);
			"
		>
			<img
				src="/assets/img/app/devices.webp"
				alt="Devices running the Jetfly Owner Mobile App"
				width="320"
				height="387"
				style="margin-left: -72px;"
			/>
			<div
				class="flex flex-col gap-5 w-screen"
				style="max-width: 295px;"
			>
				<StoreButton
					v-for="storeButton in storeButtons"
					:key="storeButton.key"
					:url="storeButton.url"
					:name="storeButton.name"
					:icon="storeButton.icon"
					:qrSrc="storeButton.qrSrc"
				/>
			</div>
		</section>
	</FadeSlideUp>
</template>
